import React from "react";
import { Linkify } from "@/components/Linkify";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Req = ({ el }) => (el.required ? <span className="text-destructive"> *</span> : null);

// Renders consultation-form elements exactly as the client sees them (shared by the public page and admin preview).
export const FormFields = ({ elements = [], answers = {}, set }) => (
  <>
    {elements.map((el) => (
      <div key={el.id} data-testid={`field-${el.id}`}>
        {el.type === "heading" && <h2 className="font-heading font-semibold text-lg pt-2">{el.label}</h2>}
        {el.type === "text" && <p className="text-sm text-muted-foreground whitespace-pre-line"><Linkify text={el.label} /></p>}
        {el.type === "client_details" && (
          <div className="space-y-2">
            <label className="text-sm font-medium">{el.label || "Your details"}</label>
            <Input placeholder="Full name" value={answers[`${el.id}_name`] || ""} onChange={(e) => set(`${el.id}_name`, e.target.value)} className="h-10 rounded-lg" />
            <Input placeholder="Email" value={answers[`${el.id}_email`] || ""} onChange={(e) => set(`${el.id}_email`, e.target.value)} className="h-10 rounded-lg" />
            <Input placeholder="Phone" value={answers[`${el.id}_phone`] || ""} onChange={(e) => set(`${el.id}_phone`, e.target.value)} className="h-10 rounded-lg" />
          </div>
        )}
        {(el.type === "short" || el.type === "signature") && (
          <div className="space-y-1"><label className="text-sm font-medium">{el.label}<Req el={el} /></label>
            <Input value={answers[el.id] || ""} onChange={(e) => set(el.id, e.target.value)} placeholder={el.type === "signature" ? "Type your full name to sign" : ""} className="h-10 rounded-lg" data-testid={`input-${el.id}`} /></div>
        )}
        {el.type === "long" && (
          <div className="space-y-1"><label className="text-sm font-medium">{el.label}<Req el={el} /></label>
            <Textarea value={answers[el.id] || ""} onChange={(e) => set(el.id, e.target.value)} className="rounded-lg" data-testid={`input-${el.id}`} /></div>
        )}
        {el.type === "date" && (
          <div className="space-y-1"><label className="text-sm font-medium">{el.label}<Req el={el} /></label>
            <Input type="date" value={answers[el.id] || ""} onChange={(e) => set(el.id, e.target.value)} className="h-10 rounded-lg w-48" data-testid={`input-${el.id}`} /></div>
        )}
        {el.type === "choose" && (
          <div className="space-y-1"><label className="text-sm font-medium">{el.label}<Req el={el} /></label>
            <Select value={answers[el.id] || ""} onValueChange={(v) => set(el.id, v)}>
              <SelectTrigger className="h-10 rounded-lg" data-testid={`input-${el.id}`}><SelectValue placeholder="Select…" /></SelectTrigger>
              <SelectContent>{(el.options || []).map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
            </Select></div>
        )}
        {el.type === "checkbox" && (
          <label className="flex items-start gap-2 text-sm cursor-pointer"><Checkbox checked={!!answers[el.id]} onCheckedChange={(v) => set(el.id, !!v)} data-testid={`input-${el.id}`} /><span>{el.label}<Req el={el} /></span></label>
        )}
      </div>
    ))}
  </>
);
